import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import VmFilter from "../../components/dashboardComponents/AlertsComponents/vmFilter";
import AlertsSummaryComponent from "../../components/dashboardComponents/AlertsComponents/alertsSummaryComponent";
import AlertHeatmapComponent from "../../components/dashboardComponents/AlertsComponents/AlertHeatmapComponent";
import AlertsTableComponents from "../../components/dashboardComponents/AlertsComponents/AlertsTableComponent";
import PeriodFilter from "../../components/productsInfosComponents/PerformancePageComponents/PeriodFilter";
import AIAlertAnalysisCard from "../../components/dashboardComponents/AlertsComponents/AIAlertAnalysisCard";

const AlertPage = () => {
  const location = useLocation();
  const [selectedVmId, setSelectedVmId] = useState(0);
  const [rangeStartDate, setRangeStartDate] = useState("");
  const [rangeEndDate, setRangeEndDate] = useState("");

  useEffect(() => {
    if (location.state?.selectedVmId) {
      setSelectedVmId(location.state.selectedVmId);
    }
  }, [location.state]);

  const handleRangeChange = (startDate, endDate) => {
    setRangeStartDate(startDate);
    setRangeEndDate(endDate);
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        <h1 className="text-xl sm:text-2xl font-bold text-primary-dark">Alerts</h1>
        <div className="flex flex-wrap gap-3 items-center w-full sm:w-auto">
          <PeriodFilter onRangeChange={handleRangeChange} />
          <VmFilter selectedVmId={selectedVmId} onVmChange={setSelectedVmId} />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row gap-6 items-stretch">
        <div className="w-full lg:w-[60%]">
          <AlertsSummaryComponent 
            vmId={selectedVmId} 
            startDate={rangeStartDate}
            endDate={rangeEndDate}
          />
        </div>
        <div className="w-full lg:w-[40%]">
          <AlertHeatmapComponent 
            vmId={selectedVmId}
          />
        </div>
      </div>
      <AIAlertAnalysisCard vmId={selectedVmId} />
      <AlertsTableComponents 
        vmId={selectedVmId}
      />
    </div>
  );
};

export default AlertPage;